import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    headerPosition: 0,
    tlheight: 0,
    player: null,
    decades: [
      {
        title: '2010',
        content: '<p>Este modelo, el más reciente, fue presentado en 2012. Llamó la atención por su diseño y óptima calidad, tanto que fue elegido el “Auto del Año” en Chile y a nivel internacional. Esto, gracias a que incorpora toda la tecnología de última generación de la industria automotriz con sus motorizaciones diesel y gasolina ecológica.</p><p>Esta época se caracteriza por la llegada de sonidos provenientes de América Latina, a través del reggaetón. Daddy Yankee, considerado “El Rey” de este género, llegó para quedarse y con Gasolina generó un nuevo fenómeno cultural. A este éxito se sumaron otros como Don Omar, los dúos Zion y Lennox, y Wisin y Yandel.</p><p>Ha sido tanto el éxito del reggaetón, que incluso artistas como Justin Bieber o Beyoncé han incursionado en este estilo, haciendo colaboraciones con Daddy Yankee y Luis Fonsi– para Despacito– y con Maluma.</p><p> Tras la consolidación de este estilo, surgió el trap, con exponentes como Travis Scott o Drake.</p>',
        carmodel: 'Peugeot 208',
        orientation: 'left',
        carpic: 'assets/images/208.png',
        share: {
          fbtitle: 'En mi Peugeot suena TRAP',
          fbdescription: 'Voy escuchando Goosebumps, ¿Qué vas escuchando tú?',
          fbimg: 'assets/images/share-2010.jpg',
          twtext: 'En mi Peugeot suena TRAP || Voy escuchando Goosebumps, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        videos: [
          {
            musicurl: 'assets/videos/2010-travis-scott-goosebumps.mp4',
            musicposter: 'assets/videos/2010-travis-scott-goosebumps.jpg',
            musicgenre: 'TRAP',
            seek: '100'
          }
        ],
        colorscheme: {
          background: '#fffd38',
          title: 'black',
          text: 'black',
          car: 'black'
        }
      },
      {
        title: '2000',
        content: '<p>En 2006 se lanzó por primera vez el Peugeot 207, que terminó de fabricarse en 2012. El modelo se caracterizó por tener más amplitud en su interior, con siluetas aerodinámicas de vanguardia.</p><p>Esta década estuvo marcada por el surgimiento de artistas con sonidos intermedios entre el pop y el rock, los que alcanzaron rápidamente un espacio dentro de la industria musical, como Avril Lavigne, quien con temas como Let Go y Complicated, logró identificar a miles de adolescentes, a través de sus letras y su estilo skater.</p><p>Luego, en 2008, Lady Gaga con Just Dance, el primer single de su álbum debut, The Fame, logró su primera nominación en los premios Grammy y pasó a ser, en poco tiempo, una de las artistas más exitosas, con temas como Poker Face o Bad Romance. Su talento, sumado a su llamativo y excéntrico look, con peinados poco usuales, exceso de maquillaje y coreografías osadas, le otorgó rápidamente un importante espacio dentro de la industria.</p><p>Por otro lado, Linkin Park, con el lanzamiento de su primer álbum Hybrid Theory, que incluye temas como In The End o Papercut, representaba un estilo con guiños al rock, rap y otros sonidos más eléctricos.</p><p>Aquí también apareció Beyoncé, quien en 2003, lanzó su primer álbum: Dangerously in Love, dando los que serían sus primeros pasos para convertirse en una estrella del pop.</p>',
        carmodel: 'Peugeot 207',
        share: {
          fbtitle: 'En mi Peugeot suena NUMETAL',
          fbdescription: 'Voy escuchando In The End, ¿Qué vas escuchando tú?',
          fbimg: 'assets/images/share-2000.jpg',
          twtext: 'En mi Peugeot suena NUMETAL || Voy escuchando In The End, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/207.png',
        videos: [{
          musicurl: 'assets/videos/2000-linkin-park-in-the-end.mp4',
          musicposter: 'assets/videos/2000-linkin-park-in-the-end.jpg',
          musicgenre: 'NUMETAL',
          seek: '100'
        }],
        colorscheme: {
          background: '#2d348b',
          title: 'white',
          text: 'black',
          car: '#120202'
        }
      },
      {
        title: '90',
        content: '<p>Con este modelo, que se lanzó en 1998 y terminó de fabricarse en 2016, Peugeot rompió todos los esquemas y se convirtió en el más vendido de la marca en Chile. Su diseño rupturista y versatilidad lo posicionó como el preferido de los jóvenes. Líder también en lo deportivo, obtuvo grandes triunfos en el automovilismo.</p><p>El máximo exponente, en esta década, fue el grunge, un nuevo sonido proveniente de Seattle. El lanzamiento de Nevermind, de Nirvana, en 1992, marcó a toda una generación y pasó a la historia con canciones como Smells Like Teen Spirit y Come As You Are. Kurt Cobain se convirtió rápidamente en un ídolo, situación que lejos de acomodarlo, lo tuvo siempre conflictuado. En paralelo, en Inglaterra reinaba el Brit Pop, con bandas como Blur, Oasis y Pulp.</p><p> A fines de los 90, en 1996, aparecieron las Spice Girls, cuyos fanáticos, hasta el día de hoy, sueñan con que se reúnan nuevamente. Wannabe fue el single con el que debutó esa agrupación, el que pasó a ser el número uno, en 31 países. A este boom, se sumó Britney Spears, quien en 1998 lanzó Baby One More Time, logrando llegar al número uno de los Billboard Hot 100, convirtiéndose en un verdadero ícono del pop y en el centro de atención de los medios y paparazzis.</p>',
        carmodel: 'Peugeot 206',
        share: {
          fbtitle: 'En mi Peugeot suena GRUNGE',
          fbdescription: 'Voy escuchando Smells Like Teen Spirit, ¿Qué vas escuchando tú?',
          fbimg: 'assets/images/share-90.jpg',
          twtext: 'En mi Peugeot suena GRUNGE || Voy escuchando Smells Like Teen Spirit, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/206.png',
        videos: [{
          musicurl: 'assets/videos/90-nirvana-smell.mp4',
          musicposter: 'assets/videos/90-nirvana-smell.jpg',
          musicgenre: 'GRUNGE',
          seek: '58'
        }],
        colorscheme: {
          background: '#c2d336',
          title: 'white',
          text: '#3b352b',
          car: '#120202'
        }
      },
      {
        title: '80',
        content: '<p>En 1983 se lanzó el Peugeot 205, que llamó la atención por el cómodo espacio interior que ofrecía, pese a ser un auto pequeño. Un año después apareció el  primer 205 GTI, cuyo éxito no decae. Se trata de un modelo revelación del mercado, denominado “número sagrado” debido a sus ventas, preferencia del público en el mercado y múltiples logros en los mundiales de Rally y de Dakar.</p><p>Aquí las guitarras eléctricas quedaron un tanto atrás y se dio paso a nuevas tecnologías, entre ellas, los sintetizadores, responsables del nacimiento de una nueva era, esta vez basada en el pop.</p><p>El surgimiento del canal MTV influyó en la radical transformación de la música y provocó un nuevo fenómeno: ahora los artistas podrían salir en televisión y dar a conocer sus canciones con videoclips.</p><p>Uno de los íconos más importantes de la década, fue Michael Jackson, “El Rey del Pop”, quien ya con su carrera en solitario alcanzó el éxito mundial y, a la par, despertó el interés de los medios de comunicación en torno a su vida privada. El lanzamiento de su álbum Thriller, en 1982, no solo se materializó en importantes reconocimientos, sino que también el videoclip del sencillo fue pionero en su especie, al contar un relato e incluir un corto de 15 minutos al comienzo.</p><p>Por otro lado, Madonna, “La Reina del Pop”, en 1982 firmó contrato con Sire Records, alcanzando rápidamente los primeros lugares en importantes rankings musicales, con éxitos como Like a Virgin, Material Girl, Like a Prayer o Papa Don’t Preach. Su estilo y look influyeron además en las mujeres de la época, quienes comenzaron a optar por tops y prendas más osadas, con encaje. Su cabello rubio, rizado y corto, se transformó en todo un ícono.</p>',
        carmodel: 'Peugeot 205',
        share: {
          fbtitle: 'En mi Peugeot suena POP',
          fbdescription: 'Voy escuchando Like a Virgin, ¿Qué vas escuchando tú?',
          fbimg: 'assets/images/share-80.jpg',
          twtext: 'En mi Peugeot suena POP || Voy escuchando Like a Virgin, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/205.png',
        videos: [{
          musicurl: 'assets/videos/80-madonna-like-a-virgin.mp4',
          musicposter: 'assets/videos/80-madonna-like-a-virgin.jpg',
          musicgenre: 'POP',
          seek: '59'
        }],
        colorscheme: {
          background: '#1caae3',
          title: '#000901',
          text: '#ffffff',
          car: '#120202'
        }
      },
      {
        title: '70',
        content: '<p>El Peugeot 204 continuó fabricándose hasta 1976 y se convirtió en un verdadero clásico, ya que fue el auto más vendido de Francia entre 1969 y 1971. El modelo 204 amplió sus versiones por la gran aceptación en el mercado, especialmente debido a su rendimiento, cuando los combustibles sufrieron una importante alza. Peugeot lanzó diversas versiones como Station Wagon, Cabriolet y Furgón.</p><p>En el lado de la música, los 70s fueron el auge de muchos géneros musicales y el nacimiento de grandes clásicos de la música moderna.</p><p>Muchos, buscando llenar el vacío al éxito post-beatle, se convirtieron en un fenómeno que hoy conocemos como la avalancha británica.</p><p>El rock progresivo, el glam, el rock y la experimentación virtuosa tuvieron lugar en esta época, con nombres como David Bowie, Elton John, Marc Bolan con T-Rex, Pink Floyd, Yes, Genesis, Jethro Tull, entre muchos más.</p><p>Por otra parte, el heavy metal nace con Black Sabbath, y junto a bandas como Deep Purple y Judas Priest dan paso a la nueva ola del metal británico, con bandas como Iron Maiden y Saxon.</p><p>En esta época se crean verdaderos himnos del rock, como Stairway to Heaven de Led Zeppelin y Bohemian Rhapsody de Queen.</p><p>Como respuesta al rock virtuoso, surge el punk a finales de los 70s con exponentes como the Ramones, Sex Pistols y the Clash.</p><p>En Estados Unidos,la música disco lidera las listas, con clásicos como los Bee Gees, KC and the Sunshine band, entre otros.</p>',
        carmodel: 'Peugeot 204',
        share: {
          fbtitle: 'En mi Peugeot suena ROCK',
          fbdescription: 'Voy escuchando Bohemian Rhapsody, ¿Qué vas escuchando tú?',
          fbimg: 'assets/images/share-70.jpg',
          twtext: 'En mi Peugeot suena ROCK || Voy escuchando Bohemian Rhapsody, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/204-2.png',
        videos: [{
          musicurl: 'assets/videos/70-queen-bohemian-rhapsody.mp4',
          musicposter: 'assets/videos/70-queen-bohemian-rhapsody.jpg',
          musicgenre: 'ROCK',
          seek: '87'
        }],
        colorscheme: {
          background: '#f34e20',
          title: '#f3e0c3',
          text: '#120202',
          car: '#120202'
        }
      },
      {
        title: '60',
        content: '<p>En 1965 se lanzó el Peugeot 204 Sedan, marcando un precedente para los modelos que vendrían en el futuro. Su diseño, a diferencia de los anteriores, se caracterizó por ser más moderno: fue la primera versión de la marca con tracción delantera y motorización de tecnología avanzada.</p><p>Para la marca, esto significó el inicio de una nueva etapa, que llegó de la mano con profundos cambios y transformaciones sociales. Las mujeres tuvieron un importante rol, al manifestarse en contra de la mujer como objeto sexual, al cuestionar las opresiones del sistema patriarcal y a defender sus derechos reproductivos, pudiendo decidir sobre su cuerpo y fertilidad, con la aprobación de la píldora anticonceptiva.</p><p> Esta expresión de cultura y de liberación, estuvo acompañada por la irrupción de nuevos sonidos provenientes de Inglaterra: the Beatles, de Liverpool, y the Rolling Stones, de Londres.</p><p> Los primeros, no solo revolucionaron con sus canciones, sino también con su característico peinado, calificado como “osado” por los más tradicionales en aquella época, encabezando una verdadera revolución. Su éxito solo fue en aumento, conquistando Estados Unidos y desatando la beatlemanía cada vez que aparecían en público.</p><p> El festival Woodstock, que se realizó en 1969 y que congregó a bandas como the Who, Santana, Janis Joplin o Jimi Hendrix, se transformó en un hito clave de la historia de la música.</p>',
        carmodel: 'Peugeot 204',
        share: {
          fbtitle: 'En mi Peugeot suena ROCK',
          fbdescription: 'Voy escuchando Satisfaction, ¿Qué vas escuchando tú?',
          fbimg: 'assets/images/share-60.jpg',
          twtext: 'En mi Peugeot suena ROCK || Voy escuchando Satisfaction, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/204.png',
        videos: [{
          musicurl: 'assets/videos/60-rolling-stones-satisfaction.mp4',
          musicposter: 'assets/videos/60-rolling-stones-satisfaction.jpg',
          musicgenre: 'ROCK',
          seek: '18'
        }],
        colorscheme: {
          background: '#f0f0ee',
          title: '#ef460b',
          text: '#120202',
          car: '#120202'
        }
      },
      {
        title: '50',
        content: '<p>Durante el periodo de post-guerra se lanzó el Peugeot 203, con características más modernas y actuales. Fue presentado en 1948 y alcanzó ventas por más de 600 mil unidades, rompiendo todos los récords de producción. Fue el modelo que abrió las puertas al mercado de exportación de la marca a todo el mundo.</p><p> Sus palabras demostraron la importancia de este compositor, cantante y guitarrista, quien en los años 50, a partir de su incursión en el R & B, impuso un estilo único, que rompió esquemas y que pasó a la historia con clásicos como Roll Over Beethoven, Johnny B.Goode y Rock and Roll Music.</p><p> Esta década, además, está marcada por los inicios de Elvis Presley, quien mientras vivía en Memphis, tuvo la oportunidad de grabar en vivo para Sun Records y dar a conocer su talento. Luego, en 1955, firmó contrato con RCA y un año después, gracias a Heartbreak Hotel, su fama fue en aumento, teniendo apariciones en televisión y firmando un contrato con los estudios cinematográficos Paramount.</p><p> Su evidente éxito permitió que Presley, consagrado con el título de “El Rey del Rock and Roll”, se convirtiera en el primer ídolo juvenil, desatando la euforia e histeria entre sus fanáticas, escandalizando a los sectores más conservadores por su reconocido movimiento de cadera.</p>',
        carmodel: 'Peugeot 203',
        share: {
          fbtitle: 'En mi Peugeot suena ROCK N ROLL',
          fbdescription: 'Voy escuchando Johnny B Goode, ¿Qué vas escuchando tú?',
          fbimg: 'share-50.jpg',
          twtext: 'En mi Peugeot suena ROCK N ROLL || Voy escuchando Johnny B Goode, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/203.png',
        videos: [{
          musicurl: 'assets/videos/50-chuck-berry-johnny-b-goode.mp4',
          musicposter: 'assets/videos/50-chuck-berry-johnny-b-goode.jpg',
          musicgenre: 'ROCK N ROLL',
          seek: '100'
        }],
        colorscheme: {
          background: '#246e87',
          title: '#f3e0c3',
          text: '#120202',
          car: '#120202'
        }
      },
      {
        title: '40',
        content: '<p>El Peugeot 202 se lanzó en el Salón de París en 1938, pero su producción se detuvo en 1942 debido a los problemas generados por la Segunda Guerra Mundial. Terminado el conflicto, se reanudó su fabricación entre 1946 y 1949. Este modelo económico tuvo múltiples versiones como Sedan, Cabriolet y Furgón.</p><p> En ese entonces, en 1940, Frank Sinatra logró su primer número uno en la revista Billboard, con el tema I’ ll never smile again, y comenzó su camino al estrellato.Con este reconocimiento, que varios califican como el inicio de su carrera, Sinatra se convirtió en un verdadero fenómeno, despertando gran interés, sobre todo entre sus fanáticas, quienes, al verlo, gritaban, colapsaban las calles y lo perseguían.</p><p> Su éxito vino de la mano con la actuación, protagonizando incluso películas junto a Gene Kelly, y también trajo consecuencias en su vida privada, que pasó a ser el foco de atención de los medios. Su apuesta, como solista, se diferenciaba notoriamente de la puesta en escena de las “big bands” de la década anterior.</p>',
        carmodel: 'Peugeot 202',
        share: {
          fbtitle: 'En mi Peugeot suena JAZZ',
          fbdescription: 'Voy escuchando Anchors Aweight, ¿Qué vas escuchando tú?',
          fbimg: 'share-40.jpg',
          twtext: 'En mi Peugeot suena JAZZ || Voy escuchando Anchors Aweight, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/202.png',
        videos: [{
          musicurl: 'assets/videos/40-frank-sinatra-anchors-aweight.mp4',
          musicposter: 'assets/videos/40-frank-sinatra-anchors-aweight.jpg',
          musicgenre: 'JAZZ',
          seek: '38'
        }],
        colorscheme: {
          background: '#c6a214',
          title: 'white',
          text: '#120202',
          car: '#120202'
        }
      },
      {
        title: '30',
        content: '<p>El Peugeot 201, primer modelo de la marca producido a grandes volúmenes en la moderna industria de Sochaux – Francia, fue lanzado en 1929, en medio de un complejo escenario debido a la crisis económica mundial.</p><p>Este difícil escenario no solo tuvo efectos relacionados al comercio o al desempleo, sino que, tal como ha ocurrido en otras oportunidades, el contexto nacional se reflejó en los cambios que presentó la música, en este caso: el jazz.</p><p>Las bandas que no lograron esperanzar y entregar el sentimentalismo que necesitaban sus seguidores, fueron olvidadas, pero otras continuaron vigentes, como Fletcher Henderson Orchestra, que fue aumentando el número de los integrantes de su orquesta, dando inicio a las llamadas “big bands”.</p><p>Fletcher Henderson, con sus sonidos y arreglos, dio paso además al swing, uno de los subestilos que comenzaron a aparecer dentro del jazz. A él se suma también Benny Goodman, conocido como “El Rey del Swing”.</p>',
        carmodel: 'Peugeot 201',
        share: {
          fbtitle: 'En mi Peugeot suena SWING',
          fbdescription: 'Voy escuchando It Dont Mean a Thing if it aint got that Swing, ¿Qué vas escuchando tú?',
          fbimg: 'share-30.jpg',
          twtext: 'En mi Peugeot suena SWING || Voy escuchando It Dont Mean a Thing if it aint got that Swing, ¿Qué vas escuchando tú?',
          twhashtag: '#ritmosobreruedas',
          twimg: ''
        },
        orientation: 'left',
        carpic: 'assets/images/201.png',
        videos: [{
          musicurl: 'assets/videos/30-ella-fitzgerald-duke-ellington-it-dont-mean-a-thing.mp4',
          musicposter: 'assets/videos/30-ella-fitzgerald-duke-ellington-it-dont-mean-a-thing.jpg',
          musicgenre: 'SWING',
          seek: '1'
        }],
        colorscheme: {
          background: '#302c2b',
          title: '#f3e0c3',
          text: '#f3e0c3',
          car: '#120202'
        }
      }
    ],
    activeDecade: '2010',
    videoNotifier: null
  },
  mutations: {
    SET_ACTIVE_DECADE: (state, decade) => {
      state.activeDecade = decade
    },
    SET_HEADER_POSITION: (state, headerposition) => {
      state.headerPosition = headerposition
    },
    SET_TL_HEIGHT: (state, height) => {
      state.tlheight = height
    },
    SET_VIDEO_NOTIFIER: (state, decade) => {
      state.videoNotifier = decade
    },
    SET_PLAYER: (state, player) => {
      state.player = player
    }
  },
  actions: {
    setActiveDecade : (context, decade) => {
      context.commit("SET_ACTIVE_DECADE", decade)
    },
    setVideoNotifier: (context, decade) => {
      context.commit("SET_VIDEO_NOTIFIER", decade)
    },
    setHeaderPosition: (context, headerposition) => {
      context.commit("SET_HEADER_POSITION", headerposition)
    },
    setTlHeight: (context, height) => {
      context.commit("SET_TL_HEIGHT", height)
    },
    setPlayer: (context, player) => {
      context.commit("SET_PLAYER", player)
    }
  },
  getters: {
    getDecades: (state) => {
      return state.decades
    },
    getActiveDecadeId: (state) => {
      return state.activeDecade
    },
    getVideoNotifier: (state) => {
      return state.videoNotifier
    },
    getDecade: (state) => (key) => {
      return state.decade[key]
    },
    getActiveDecade: (state, getters) => {
      const decades = getters.getDecades
      const activeDecadeId = getters.getActiveDecadeId
      const activeDecade = decades.filter(i => i.title === activeDecadeId)
      return activeDecade[0]
    },
    getHeaderPosition: (state) => {
      return state.headerPosition
    },
    getTlHeight: (state) => {
      return state.tlheight
    },
    getPlayer: (state) => {
      return state.player
    }
  }
})
